import React, { useEffect, useState } from 'react';
import ImagePicker from '../image-picker/image-picker';
import { editorContentFromImages } from '../../lib/content-generator';

const EditorImagePicker = () => {
  const [insertEvent, setInsertEvent] = useState(null);

  useEffect(() => {
    const handleInsertEvent = e => setInsertEvent(e);

    document.addEventListener('EditorInsertImage', handleInsertEvent);

    return () => document.removeEventListener('EditorInsertImage', handleInsertEvent);
  }, []);
  
  if (insertEvent === null) {
    return <></>;
  }

  return (
    <ImagePicker
      multi={insertEvent.detail.multi}
      onCancel={() => setInsertEvent(null)}
      onPick={image => insertEvent.detail.onPick(editorContentFromImages(image))}
    />
  );
};

export default EditorImagePicker;
